import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { V2Footer } from '@uhg-abyss/web/ui/Footer';
import { styled } from '@uhg-abyss/web/tools/styled';
import { handleLogout } from '@src/tools/handleLogout';

const FooterWrapper = styled('div', {
  marginTop: 'auto',
  width: '100%',
});

const StyledV2Footer = styled(V2Footer, {
  '&.abyss-footer-root': {
    backgroundColor: '$primary1',
  },
  '&.abyss-footer-container': {
    maxWidth: '1420px',
    margin: '0 auto',
  },
  '&.abyss-link-root': {
    textDecoration: 'none',
  },
});

const StyledV2FooterLink = styled(V2Footer.Link, {
  '&.abyss-link-root': {
    textDecoration: 'none',
  },
  listStyleType: 'none',
});

export const Footer = () => {
  const { getHomePageContentByKey, getFeature } = usePPDLagoon();
  const touPdf = getHomePageContentByKey('TERMSOFUSEPDF');
  const privacyInfo = getHomePageContentByKey('PRIVACYPOLICYPDF');
  const subFooterLinks = [];

  if (getFeature('SDE_LEGAL_INFO')) {
    if (privacyInfo?.href && privacyInfo?.name) {
      subFooterLinks.push({
        label: privacyInfo.name,
        href: privacyInfo.href,
        'data-testid': 'footer-privacy-policy',
      });
    }
    if (touPdf?.href && touPdf?.name) {
      subFooterLinks.push({
        label: touPdf.name,
        href: touPdf.href,
        'data-testid': 'footer-tou',
      });
    }
    subFooterLinks.push({
      label: 'Opt Out',
      href: '/opt-out',
      'data-testid': 'footer-opt-out',
      onClick: () => event('NAVIGATION_CLICK', { name: 'Opt Out' }),
    });
  }

  const handleExitClick = (linkText) => {
    event('EXIT_LINK_NAVIGATE', { linkText });
  };
  const handleInternalLinkClick = (name) => {
    event('NAVIGATION_CLICK', { name });
  };

  return (
    <FooterWrapper>
      <StyledV2Footer
        spreadSections={true}
        subFooter={{
          copyright: 'United HealthCare Services, Inc. All rights reserved.',
          links: subFooterLinks,
        }}
      >
        <StyledV2FooterLink
          data-testid='footer-contact-us'
          href='/contact-us'
          onClick={() => handleInternalLinkClick('Contact Us')}
        >
          Contact Us
        </StyledV2FooterLink>
        <StyledV2FooterLink
          data-testid='footer-help'
          href={config('PROVIDER_SELF_SERVICE_URL')}
          onClick={() => handleInternalLinkClick('Help')}
          target='_blank'
          rel='noopener noreferrer'
        >
          Help
        </StyledV2FooterLink>
        <StyledV2FooterLink
          data-testid='footer-uhc-provider'
          href={config('UHCPROVIDER_URL')}
          target='_blank'
          rel='noopener noreferrer'
          onClick={() => handleInternalLinkClick('UHCProvider.com')}
        >
          UHC Provider
        </StyledV2FooterLink>
        <StyledV2FooterLink
          data-testid='footer-sign-out'
          href={``}
          onClick={handleLogout}
          data-uhc-brand='hyperlink--white'
        >
          Sign Out
        </StyledV2FooterLink>
      </StyledV2Footer>
    </FooterWrapper>
  );
};
